<section class="w-full flex! flex-wrap! justify-start items-center gap-3! pb-3">
    <p-float-label variant="on">
        <p-iconfield>
            <p-inputicon class="ph ph-magnifying-glass"></p-inputicon>
            <input type="text" pInputText [(ngModel)]="searchString" (ngModelChange)="emit()" />
        </p-iconfield>
        <label>{{ 'SEARCH_BY_NAME' | translate }}</label>
    </p-float-label>

    <p-float-label variant="on">
        <p-select
            [options]="triggerTypeOptions()"
            [(ngModel)]="selectedTriggerTypes"
            (ngModelChange)="emit()"
            [multiple]="true"
            optionLabel="label"
            optionValue="value"
            [filter]="false"
            class="min-w-52" />
        <label>{{ 'TRIGGER_TYPE' | translate }}</label>
    </p-float-label>

    <p-float-label variant="on">
        <p-select
            [options]="actionTypeOptions()"
            [(ngModel)]="selectedActionTypes"
            (ngModelChange)="emit()"
            [multiple]="true"
            optionLabel="label"
            optionValue="value"
            [filter]="false"
            class="min-w-52" />
        <label>{{ 'ACTION_TYPE' | translate }}</label>
    </p-float-label>

    <p-float-label variant="on">
        <p-select
            [options]="enabledFilterOptions()"
            [(ngModel)]="filterEnabled"
            (ngModelChange)="emit()"
            optionLabel="label"
            optionValue="value"
            class="min-w-36" />
        <label>{{ 'STATUS' | translate }}</label>
    </p-float-label>

    <button pButton severity="success" class="ml-auto!" (click)="newTriggerClicked.emit()">
        <i class="ph ph-plus"></i>
        {{ "NEW_TRIGGER" | translate }}
    </button>
</section>
<section class="pb-3 text-text">
    <p class="text-sm text-text-muted">{{ shownTriggers() }} {{ "TRIGGERS" | translate | lowercase }}</p>
</section>
